export default __webpack_public_path__ + "static/media/exams-animate.cd9c5e1f.svg";